import React from "react";
import PdfViewer from "../../PdfViewer";

const OperacionesGenerales = () => {
  const videoUrl = "/videos/test.mp4"

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Video Prueba</h1>
        </div>
        <div className="video-container" style={{ textAlign: "center", marginBottom: "20px" }}>
          <video 
            width="420"
            height="180" 
            controls
            style={{ maxWidth: "30%", height:"30%", borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0,0,0,0.2)" }}
          >
            <source src={videoUrl} type="video/mp4" />
            Tu navegador no soporta la reproducción de video.
          </video>
        </div>
      </main>
    </>
  );
};

 export default OperacionesGenerales;
